(function() {
  define('tlhServicesPicture',['angular'], function() {
    'use strict';
    return angular.module('tlhServicesPicture', []).factory('TlhPictureService', [
      function() {
        var factory;
        factory = {};
        factory.hasPreviewPicture = function(pictures) {
          var picture, result, _i, _len;
          result = false;
          for (_i = 0, _len = pictures.length; _i < _len; _i++) {
            picture = pictures[_i];
            if (picture.isActive && picture.isPreviewPicture) {
              result = true;
              break;
            }
          }
          return result;
        };
        return factory;
      }
    ]);
  });

}).call(this);

//# sourceMappingURL=picture.js.map
;
